@if (isEditDeleteViewAvailable()) {
  <pas-button-round
    [color]="pasButtonRoundColor.DARK"
    (click)="onEditClicked('')"
    icon="mode_edit"
    size="small"></pas-button-round>
}
